import { render, staticRenderFns } from "./purchaseAudit.vue?vue&type=template&id=c2874a50&scoped=true"
import script from "./purchaseAudit.vue?vue&type=script&lang=js"
export * from "./purchaseAudit.vue?vue&type=script&lang=js"
import style0 from "./purchaseAudit.vue?vue&type=style&index=0&id=c2874a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2874a50",
  null
  
)

export default component.exports